import './common.css';
import './giveaways.css';
import './home.css';

export default {};